"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = exports.get = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization Id'),
    productId: validation_1.default.rules.string().required().label('Product Id'),
};
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.get = { params: getParams };
const getByIdParamRules = {
    ...getParamRules,
    topicId: validation_1.default.rules.string().required().label('Privacy Topic Id'),
};
const getByIdParams = {
    rules: getByIdParamRules,
    schema: validation_1.default.schema(getByIdParamRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.getById = { params: getByIdParams };
